import {NgModule} from '@angular/core';
import {ActionBoardModule} from '../../../../shared-components/action-board/action-board.module';
import {WorkspaceModule} from '../../../../shared-components/workspace/workspace.module';
import {EtsTradingPadModule} from '../trading-pad/trading-pad.module';
import {EtsGatewayManagerModule} from '../gateways/gateway-manager.module';
import {EtsTerminalExitModule} from '../terminal-exit/terminal-exit.module';
import {
    TotalStrategyIssuesModule
} from '../../../../shared-components/total-strategy-issues/total-strategy-issues.module';
import {WebtraderHostMenuModule} from '../host-menu/host-menu.module';
import {WebtraderHostComponent} from './host.component';
import {ServerTimePanelComponent} from './server-time-panel/server-time-panel.component';
import {TelegramConnectionsModule} from 'projects/shared-components/telegram-connections/telegram-connections.module';
import {PnlBoxComponent} from './pnl-box/pnl-box.component';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '../../../../shared-components/layout/layout.module';
import {UnaccountedDataModule} from '../unaccounted-data/unaccounted-data.module';
import {AngularSplitModule} from 'angular-split';
import {DevExtremeModule} from 'projects/shared-components/devextreme.module';
import {JobsTrackerModule} from 'projects/shared-components/jobs-tracker/jobs-tracker.module';
import {EtsShellMessagesModule} from 'projects/shared-components/shell-messages/shell-messages.module';
import {ResourceEditorModule} from "../../../../shared-components/resource-editor/resource-editor.module";
import {LastPriceModule} from "../../../../shared-components/last-price/last-price.module";
import {OptionsPricingGridModule} from "../../../../shared-components/options-pricing-grid/options-pricing-grid.module";
import {PivotPointsPopupModule} from "../../../../shared-components/pivot-points-popup/pivot-points-popup.module";
import {QuoteGeneratorModule} from "../../../../shared-components/quote-generator/quote-generator.module";
import {QuoteRateLimiterModule} from "../../../../shared-components/quote-rate-limiter/quote-rate-limiter.module";
import {
    CurrentZoneIndicatorModule
} from "../../../../shared-components/current-zone-indicator/current-zone-indicator.module";
import {
    SkewSentimentIndicatorModule
} from "../../../../shared-components/skew-sentiment/skew-sentiment-indicator.module";
import {
    HorizontalSkewModule
} from "../../../../shared-components/horizontal-skew/horizontal-skew.module";

@NgModule({
    imports: [
        TelegramConnectionsModule,
        CommonModule,
        DevExtremeModule,
        LayoutModule,
        AngularSplitModule,
        WorkspaceModule,
        EtsTradingPadModule,
        EtsGatewayManagerModule,
        EtsTerminalExitModule,
        EtsShellMessagesModule,
        WebtraderHostMenuModule,
        TotalStrategyIssuesModule,
        UnaccountedDataModule,
        JobsTrackerModule,
        ResourceEditorModule,
        LastPriceModule,
        OptionsPricingGridModule,
        PivotPointsPopupModule,
        QuoteGeneratorModule,
        QuoteRateLimiterModule,
        CurrentZoneIndicatorModule,
        SkewSentimentIndicatorModule,
        HorizontalSkewModule,
        // CR-20260922-001 — the Action Board overlay + footer badge.
        ActionBoardModule,
    ],

    declarations: [
        WebtraderHostComponent,
        ServerTimePanelComponent,
        PnlBoxComponent,
    ]
})
export class WebtraderHostModule {
}
